import {Injectable} from '@angular/core';
import {TranslateService} from "../../shared/translate.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {UserNotification} from "./user-notification";
import {environment} from "../../../environments/environment";
import {Observable} from "rxjs";
import {BaseUserService} from "../account/base-user.service";
import {PageResult} from "../../shared/page-result";

@Injectable({
  providedIn: 'root'
})
export class UserNotificationService extends BaseUserService {

  allNotificationsUrl: string = "portalApiUrl/omnis/user/notification";

  constructor(private translateService: TranslateService, private http: HttpClient) {
    super();
  }

  markAsRead(notificationId: number, token: string): Observable<void> {
    return this.http.post<void>(`${this.allNotificationsUrl}/${notificationId}`,
      {}, {headers: this.createHeaders(token)});
  }

  getUserNotifications(page: number, pageSize: number, token: string): Observable<PageResult<UserNotification>> {
    let params = new HttpParams().set('page', page.toString()).set('pageSize', pageSize.toString());
    return this.http.get<PageResult<UserNotification>>(this.allNotificationsUrl, {
      headers: this.createHeaders(token),
      params: params
    });
  }
}
